import { render, staticRenderFns } from "./IconSvgWebm.vue?vue&type=template&id=274fac64&scoped=true&"
import script from "./IconSvgWebm.vue?vue&type=script&lang=js&"
export * from "./IconSvgWebm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274fac64",
  null
  
)

export default component.exports